module.exports = __webpack_public_path__ + "static/media/varie3.0b077ef5.jpg";